var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1019,
    height: 1024,
    viewBox: "0 0 1019 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M733.832 456.488C767.283 456.488 784.008 469.459 784.008 495.4C784.008 498.131 783.325 503.592 781.96 511.784C770.355 548.648 744.755 567.08 705.16 567.08H548.488L512.648 701.224C507.869 720.339 499.336 734.675 487.048 744.232C475.443 753.789 461.789 758.568 446.088 758.568C430.387 758.568 417.757 754.472 408.2 746.28C399.325 737.405 394.888 725.459 394.888 710.44C394.888 702.931 395.912 695.08 397.96 686.888L430.728 567.08H279.176C262.792 567.08 250.163 564.008 241.288 557.864C233.096 551.037 229 541.821 229 530.216C229 524.755 230.024 518.611 232.072 511.784C236.851 494.035 245.725 480.381 258.696 470.824C271.667 461.267 288.051 456.488 307.848 456.488H460.424L496.264 322.344C501.043 303.229 509.235 288.893 520.84 279.336C532.445 269.779 546.099 265 561.8 265C577.501 265 589.789 269.437 598.664 278.312C608.221 286.504 613 298.109 613 313.128C613 320.637 611.976 328.488 609.928 336.68L578.184 456.488H733.832Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 229,
    y1: 265,
    x2: 828.033,
    y2: 325.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F13BF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.e6363ddc30803986b50b59f55a782fd4.svg";
export { ForwardRef as ReactComponent };